<template>
  <el-select
      v-model="resources_list"
      :multiple="multiple"
      filterable
      :placeholder="placeholder || $t('ReportBuilder.constructor.allResources')" style="width: 240px" class="text-dark text-sm">
    <el-option
        v-if="allResourcesOption"
        :label="$t('ReportBuilder.constructor.allResources')"
        value="$all_resources"
    />
    <el-option
        v-if="!resourceType"
        :label="$t('ReportBuilder.constructor.currentResource')"
        value="$current_resource"
    />
    <el-option
        v-for="resource in filteredResources"
        :key="resource.key"
        :label="resource.bot_name"
        :value="resource.key"
    />
  </el-select>
</template>

<script>
const RESOURCE_TYPE_BOT = 1
const RESOURCE_TYPE_CHANNEL = 2

export default {
  name: "ResourceSelector",
  props: {
    modelValue: [String, Array],
    multiple: {
      type: Boolean,
      default: false
    },
    // Restrict the list to a resource kind: 'bot' (type=1), 'channel' (type=2), or null for all
    // (also shows the "current resource" placeholder option, meaningless once filtered to one kind).
    resourceType: {
      type: String,
      default: null,
      validator: (value) => value === null || ['bot', 'channel'].includes(value)
    },
    // Opt-in: explicit "all resources" choice ($all_resources) as a *value*. By default an empty
    // selection already means "all", but where empty carries its own meaning (event blocks:
    // "same resource as the users filter") the choice has to be selectable, not implied.
    allResourcesOption: {
      type: Boolean,
      default: false
    },
    // Overrides the "All resources" placeholder for those same cases.
    placeholder: {
      type: String,
      default: null
    }
  },
  computed: {
    filteredResources() {
      const wantedType = this.resourceType === 'channel' ? RESOURCE_TYPE_CHANNEL
        : this.resourceType === 'bot' ? RESOURCE_TYPE_BOT
        : null
      // user_bots is an object keyed by resource key (ArrayHelper::index on the backend), not
      // an array — Object.values() normalizes both that and the initial `[]` default.
      const resources = Object.values(this.$store.state.init.user_bots)
      return wantedType === null ? resources : resources.filter((resource) => resource.type === wantedType)
    },
    resources_list: {
      get: function () {
        return this.modelValue
      },
      set: function (value) {
        this.$emit('update:modelValue', value)
      }
    }
  }
}
</script>

<style scoped>

</style>
